import { IdNameItem } from "@/dto/responses/id.name.response";
import { CreateUserRequest, FilterProfilesRequest, FilterUsersRequest, User, UserProfileItem } from "@/models/user";
import popupService from "@/services/popupService";
import { sleep } from "@/util";
import { makeAutoObservable } from "mobx";
import api from "../services/api";

const delay = sleep(400);

export class UserStore {
    userGroups: IdNameItem[] = [];
    userProfiles: UserProfileItem[] = [];
    autocompleteOrganizations: IdNameItem[] = [];
    userData: User = new User();

    constructor() {
        makeAutoObservable(this);
    }

    public createUser = async (request: CreateUserRequest) => {
        popupService.showLoading();
        try {
            await delay;
            var response = await api.createUser(request);
            popupService.close();
            return response;
        } catch (error) {
            popupService.showApiError(error);
        }
    };

    public getUserGroups = async () => {
        var response = await api.getUserGroups();
        this.userGroups = response.data.result;
    };
    public getUserProfiles = async (request: FilterProfilesRequest) => {
        var response = await api.getUserProfiles(request);
        this.userProfiles = response.data.rows;
    };

    public getUsers = async (filter: FilterUsersRequest) => {
        popupService.showLoading();
        await delay;
        var response = await api.getUsers(filter);
        popupService.close();
        //this.usersResponse = response.data;
        return response.data;
    };

    public getUserInfo = async (id: number) => {
        popupService.showLoading();
        try {
            await delay;
            var response = await api.getUserInfo(id);
            popupService.close();
            return response;
        } catch (error) {
            popupService.showApiError(error);
        }
    };

    public editUser = async (request: User) => {
        popupService.showLoading();
        try {
            await delay;
            var response = await api.editUser(request);
            popupService.close();
            return response;
        } catch (error) {
            popupService.showApiError(error);
            return;
        }
    };
    public deleteUser = async (userId: number) => {
        popupService.showLoading();
        try {
            await delay;
            var response = await api.deleteUser(userId);
            popupService.close();
            return response;
        } catch (error) {
            popupService.showApiError(error);
            return;
        }
    };

    public setUserData = (user: User) => {
        this.userData = user;
    };
}

const userStore = new UserStore();
export default userStore;
